import Vue from 'vue'
import VueRouter from 'vue-router'
import { common } from "@/utils/common";
import { captureFbc } from "@/utils/facebook.js";
import { captureReferrer } from "@/utils/origen.js";
import { mergeRouteQuery, sameRouteQuery } from "@/utils/withTrackingParams";
import store from "@/store";
import { trackAfiliacionAbandono } from "@/utils/ga4Events";

Vue.use(VueRouter)

const routes = [
  // Home -> redirige al selector de ciudades de Conecta
  { path: '/', redirect: to => ({ path: '/conecta/locations', query: to.query }) },
    // Landing (marketing)
  {
    path: '/urgconecta',
    name: 'landing',
    component: () => import('../views/Landing.vue'),
  },
   { path: '/promotor', component: () => import('../views/PromotorView.vue') },
  // Layout de Conecta + subrutas
  {
    path: '/conecta',
    component: () => import('../views/ConectaLayout.vue'),
    children: [
      { path: '', redirect: 'locations' },
      {
        path: 'locations',
        name: 'conecta-locations',
        component: () => import('../views/ConectaLocationsView.vue'),
      },
      {
        path: 'contact',
        name: 'conecta-contact',
        component: () => import('../views/ConectaContactView.vue'),
      },
      {
        path: 'form',
        name: 'conecta-form',
        component: () => import('../views/ConectaView.vue'),
      },
    ],
  },

  // Cualquier otra ruta -> a locations
  { path: '*', redirect: to => ({ path: '/conecta/locations', query: to.query }) },
  // Ruta de login de Promotor


]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
})

router.beforeEach(async (to, from, next) => {

    // El fbclid del anuncio solo esta en la URL de la primera pantalla y se pierde en la
    // primera recarga, mucho antes del Purchase.
    captureFbc();
    captureReferrer();

  // Detectar abandono del flujo de afiliación
  if (from.name === 'conecta-form' && to.name !== 'conecta-form') {
    const cotizacionStarted = store.state.Conecta && store.state.Conecta.Cotizacion;
    if (cotizacionStarted) {
      trackAfiliacionAbandono(store.state.Conecta.Product);
    }
  }

  const fromQuery = from.query || {};
  const targetQuery = to.query || {};
  const mergedQuery = mergeRouteQuery(fromQuery, targetQuery);

  if (Object.keys(fromQuery).length > 0 && !sameRouteQuery(mergedQuery, targetQuery)) {
    return next({
      path: to.path,
      params: to.params,
      hash: to.hash,
      query: mergedQuery,
      replace: true,
    });
  }

  try {
    const entries = Object.entries(to.query || {});
    const Queries = entries.flatMap(([key, value]) => {
      if (Array.isArray(value)) return value.map(v => ({ key, value: String(v) }));
      if (value == null) return [];
      return [{ key, value: String(value) }];
    });
    await common(Queries);
  } catch (e) {}

  return next();
});

export default router
